import React from "react";
import "./CardInformation.css"; // Certifique-se de importar ou adicionar os estilos necessários
import { Cupom } from "../../services/onboarding";
import { formatToBRL } from "../../utils/formatToBRL";
import { useTenantStore } from "../../stores/tenant/use-tenant-store";

export interface ItemProps {
  label: string;
  value: string;
}

interface CardInformationProps {
  discount: string;
  consumoMensal: string;
  economiaAnual: string;
  cupom: Cupom | null;
}

const CardInformation = ({ discount, consumoMensal, economiaAnual, cupom }: CardInformationProps) => {
  return (
    <section className="section-container-card-information">
      <section className="card-information">
        <div className="data-container" id="template-areas">
          <div id="discount-div">
            <h4 className="label">Você economizará</h4>
            <p className="discount">
              {discount}
              <b className="porcentagem">%</b>
            </p>
          </div>

          <div id="economy-div">
            <h4 className="label">Economia anual*</h4>
            <b className="value-bold">{economiaAnual}</b>
          </div>
          <div id="consumo-div">
            <h4 className="label">Estimativa do consumo mensal</h4>
            <b className="value-bold">{consumoMensal}</b>
          </div>
        </div>
      </section>

      {cupom != null ? (
        <div className="bg-zinc-900 *:text-zinc-100 py-2 px-5 [&_strong]:text-[var(--main-color)]">
          <p className="font-kumbh-sans text-sm hidden md:block">
            Com cupom <strong>{cupom?.codigo}</strong> você garantiu <strong>{formatToBRL(cupom?.valor || 0)}</strong> de economia na
            primeira fatura.
          </p>
          <p className="font-kumbh-sans text-sm md:hidden">
            Cupom <strong>{cupom?.codigo}</strong> aplicado! <strong>{formatToBRL(cupom?.valor || 0)}</strong> de economia na 1ª fatura.
          </p>
        </div>
      ) : null}

      <div className="container-asterisco">
        <p className="asterisco-info-card-info">
          *A economia anual é calculada de acordo com a média de consumo de energia presente na fatura fornecida.
        </p>
        <p className="asterisco-info-card-info">**A economia varia de acordo com o consumo.</p>
      </div>
    </section>
  );
};

export default CardInformation;
